// Каталог магазина экспедиции. Один источник для главной, /catalog и карточек /catalog/[slug].

export type Category = "kits" | "optics" | "gear" | "paper" | "kids" | "merch" | "feed";

export const CATEGORIES: { id: Category; label: string }[] = [
  { id: "kits", label: "Наборы" },
  { id: "optics", label: "Оптика" },
  { id: "gear", label: "Снаряжение" },
  { id: "paper", label: "Бумага" },
  { id: "kids", label: "Детям" },
  { id: "merch", label: "Мерч" },
  { id: "feed", label: "Корм и кормушки" },
];

export type Variant = { name: string; price: number; oldPrice?: number; note?: string; contents?: string[] };
export type Review = {
  author: string;
  role?: string;
  rating: number;
  date: string;
  text: string;
  pros?: string;
  cons?: string;
  variant?: string;
  helpful: number;
  photos?: string[];
  answer?: string;
};

export type Product = {
  slug: string;
  sku: string;
  category: Category;
  name: string;
  subtitle: string;
  badge?: { text: string; tone?: "new" | "sale" };
  images: { src: string; caption: string }[];
  has3d?: boolean;
  lead: string;
  story: string[];
  features: { title: string; text: string }[];
  specs: [string, string][];
  variantLabel?: string;
  variants: Variant[];
  sizeChart?: boolean;
  stock: number;
  rating: number;
  ratingCount: number;
  dist: [number, number, number, number, number]; // доля оценок 5…1, %
  reviews: Review[];
  qa: { q: string; author: string; a: string }[];
  related: string[];
  popular: number;
  added: number;
};

export const PRODUCTS: Product[] = [
  {
    slug: "nabor-pervyj-ptenec",
    sku: "НИИ-0417-01",
    category: "kits",
    name: "Набор наблюдателя «Первый птенец»",
    subtitle: "Всё для первого выхода на карниз",
    badge: { text: "Выбор института" },
    images: [
      { src: "/catalog/k1.jpg", caption: "Набор целиком" },
      { src: "/catalog/k2.jpg", caption: "В работе у окна" },
      { src: "/catalog/k3.jpg", caption: "Упаковка" },
      { src: "/catalog/b1.jpg", caption: "Бинокль из набора" },
    ],
    lead: "Если долго стоять во дворе с биноклем и блокнотом, соседи начинают думать, что у вас есть основания. Этот набор их даёт.",
    story: [
      "Набор собран отделом полевых наблюдений по итогам 39 лет безуспешных поисков. В нём нет ничего лишнего, кроме надежды.",
      "Бинокль покажет карниз в деталях. Журнал сохранит то, что вы видели, и отдельно — то, что вам показалось. Определитель поможет отличить голубя от очень убедительного кандидата. Значок объяснит окружающим, почему вы смотрите на крышу.",
    ],
    features: [
      { title: "Карниз в 8 раз ближе", text: "Бинокль 8×21 достаёт до девятого этажа со двора. До птенца — пока нет." },
      { title: "Две колонки в журнале", text: "«Видел» и «Показалось». Институт рекомендует заполнять обе." },
      { title: "Определитель на 12 птиц", text: "Раскладывается быстрее, чем формируется уверенное мнение." },
      { title: "Значок участника", text: "Номер экспедиции выбит на обороте. Дубликаты не выдаются." },
    ],
    specs: [
      ["Бинокль", "8×21, призмы BaK-4, вес 210 г"],
      ["Журнал", "А6, 96 листов, бумага 120 г/м²"],
      ["Определитель", "Гармошка, 12 видов городских птиц"],
      ["Значок", "Твёрдая эмаль, 32 мм"],
      ["Кейс", "Крафт-картон, ложемент из EVA"],
      ["Вес набора", "640 г"],
      ["Гарантия", "Бинокль — 2 года, надежда — без срока"],
    ],
    variantLabel: "Комплектация",
    variants: [
      {
        name: "Наблюдатель",
        price: 6900,
        oldPrice: 7900,
        note: "Для первого выхода во двор.",
        contents: ["Бинокль 8×21", "Полевой журнал", "Карандаш без регистрации", "Значок участника"],
      },
      {
        name: "Исследователь",
        price: 8900,
        note: "Когда случайное наблюдение стало системой.",
        contents: ["Бинокль 8×21", "Полевой журнал", "Два карандаша без регистрации", "Определитель «Голубь или нет»", "Значок участника", "Карта наблюдений района"],
      },
      {
        name: "Руководитель",
        price: 12900,
        note: "Чтобы кто-то наконец отвечал за вопросы.",
        contents: ["Бинокль 8×21 в чехле", "Два полевых журнала", "Три карандаша без регистрации", "Определитель «Голубь или нет»", "Два значка участника", "Карта наблюдений района", "Папка «На дополнительную проверку»", "Удостоверение руководителя экспедиции"],
      },
    ],
    stock: 14,
    rating: 4.8,
    ratingCount: 126,
    dist: [86, 9, 3, 1, 1],
    reviews: [
      { author: "Олег К.", rating: 5, date: "2026-10-03", variant: "Исследователь", text: "Взял себе и сыну. Три выходных сидели на крыше гаража. Птенца не нашли, зато сын впервые за год отложил телефон. Журнал исписали наполовину, в основном колонку «Показалось».", pros: "Бинокль правда хороший, кейс крепкий", cons: "Птенца в комплекте нет", helpful: 48, photos: ["/catalog/r1.jpg"], answer: "Олег, птенец не входит в комплектацию ни одной версии набора. Это сознательное решение учёного совета." },
      { author: "Марина", rating: 5, date: "2026-09-21", variant: "Наблюдатель", text: "Дарила мужу на день рождения. Теперь по утрам он не пьёт кофе, а «проверяет карниз». Довольны оба, карниз — не очень.", helpful: 31 },
      { author: "Сергей Л.", role: "Опекун голубя", rating: 4, date: "2026-08-30", variant: "Руководитель", text: "Удостоверение руководителя работает: охранник торгового центра пустил на крышу парковки. Снял звезду за то, что карандаша три, а рук две.", helpful: 17 },
    ],
    qa: [
      { q: "Подойдёт ли набор для наблюдений с балкона?", author: "Алексей", a: "Подойдёт. Балкон институт считает полноценной наблюдательной площадкой первой категории." },
      { q: "Можно ли докупить значок отдельно?", author: "Вика", a: "Да, значок «Образец № 0417» продаётся отдельно. Номер экспедиции на нём будет другой." },
    ],
    related: ["binokl-karniz", "zhurnal-videl-pokazalos", "znachok-obrazec"],
    popular: 1,
    added: 4,
  },
  {
    slug: "binokl-karniz",
    sku: "НИИ-0417-02",
    category: "optics",
    name: "Бинокль «Карниз 8×21»",
    subtitle: "Достаёт до девятого этажа",
    images: [
      { src: "/catalog/b1.jpg", caption: "Бинокль" },
      { src: "/catalog/b2.jpg", caption: "На подоконнике" },
      { src: "/catalog/b3.jpg", caption: "Фокусировка и чехол" },
    ],
    lead: "Компактный бинокль для тех, кто смотрит вверх. Помещается в карман пальто и не вызывает лишних вопросов у прохожих — только правильные.",
    story: [
      "Мы протестировали его на 412 карнизах. Видно всё: штукатурку, голубей, их выражение лица. Птенцов не видно, но это претензия не к оптике.",
    ],
    features: [
      { title: "Кольцо фокуса", text: "Оранжевое, чтобы найти его в сумерках на ощупь." },
      { title: "210 граммов", text: "Шея не устаёт даже после трёх часов на карнизе." },
      { title: "Просветлённая оптика", text: "Голубь в сумерках выглядит так же подозрительно, как днём." },
    ],
    specs: [
      ["Кратность", "8×"],
      ["Диаметр объектива", "21 мм"],
      ["Поле зрения", "122 м на 1000 м"],
      ["Минимальная дистанция", "2,5 м"],
      ["Призмы", "BaK-4, Roof"],
      ["Вес", "210 г"],
      ["В комплекте", "Чехол, ремешок, салфетка"],
    ],
    variants: [{ name: "Стандарт", price: 4500 }],
    stock: 23,
    rating: 4.7,
    ratingCount: 64,
    dist: [78, 15, 4, 2, 1],
    reviews: [
      { author: "Андрей", rating: 5, date: "2026-10-11", text: "Чёткий, лёгкий. Разглядел, что у голубя на соседнем доме одна лапа меньше другой. Записал в журнал как «возможно, бывший птенец».", helpful: 22 },
      { author: "Ирина П.", rating: 4, date: "2026-09-02", text: "Хороший бинокль, но соседка напротив решила, что я смотрю на неё. Пришлось объяснять про институт. Теперь она тоже ищет.", helpful: 15 },
    ],
    qa: [{ q: "Подойдёт ли для театра?", author: "Елена", a: "Подойдёт, но голубей в театре институт не наблюдал. Если увидите — сообщите через форму № 7-П." }],
    related: ["nabor-pervyj-ptenec", "zhurnal-videl-pokazalos", "opredelitel-golub-ili-net"],
    popular: 3,
    added: 6,
  },
  {
    slug: "zhurnal-videl-pokazalos",
    sku: "НИИ-0417-03",
    category: "paper",
    name: "Полевой журнал «Видел / показалось»",
    subtitle: "Для выводов, с которыми стоит подождать",
    images: [
      { src: "/catalog/j1.jpg", caption: "Журнал" },
      { src: "/catalog/j2.jpg", caption: "Развороты" },
      { src: "/catalog/j3.jpg", caption: "Стопка экспедиции" },
    ],
    lead: "Отдельное место для того, что вы видели, и для того, что вам показалось. Карандаш всё стерпит, институт — проверит.",
    story: ["Каждый разворот разделён на две колонки. Пустая колонка «Видел» — тоже результат, и институт его ценит."],
    features: [
      { title: "Две колонки", text: "Слева — факты, справа — то, что вы хотели бы считать фактами." },
      { title: "Лён и резинка", text: "Журнал закрывается сам, даже если выводы остались открытыми." },
      { title: "Шкала на обороте", text: "Линейка в сантиметрах для оценки «примерно вот такого» размера." },
    ],
    specs: [
      ["Формат", "А6, 105 × 148 мм"],
      ["Листов", "96"],
      ["Бумага", "Слоновая кость, 120 г/м²"],
      ["Обложка", "Чёрный лён, резинка, ляссе"],
      ["Разлиновка", "Две колонки, точка 5 мм"],
    ],
    variantLabel: "Количество",
    variants: [
      { name: "1 журнал", price: 690 },
      { name: "3 журнала", price: 1790, oldPrice: 2070, note: "Для экспедиции из трёх человек или одного очень упорного." },
    ],
    stock: 58,
    rating: 4.9,
    ratingCount: 88,
    dist: [92, 6, 1, 1, 0],
    reviews: [
      { author: "Катя В.", rating: 5, date: "2026-10-14", text: "Колонку «Показалось» заполнила за неделю. Колонка «Видел» пустая, но очень красивая.", helpful: 40 },
      { author: "Пётр", rating: 5, date: "2026-09-10", text: "Бумага плотная, карандаш не продавливает. Записываю туда ещё и показания соседей.", helpful: 9 },
    ],
    qa: [{ q: "Можно писать ручкой?", author: "Глеб", a: "Можно. Но выводы ручкой институт рекомендует делать только после подтверждения." }],
    related: ["opredelitel-golub-ili-net", "nabor-pervyj-ptenec", "shoper-punktir"],
    popular: 5,
    added: 7,
  },
  {
    slug: "opredelitel-golub-ili-net",
    sku: "НИИ-0417-04",
    category: "paper",
    name: "Определитель «Голубь или нет»",
    subtitle: "12 городских птиц, один вопрос",
    images: [
      { src: "/catalog/g1.jpg", caption: "Гармошка целиком" },
      { src: "/catalog/g2.jpg", caption: "В поле" },
      { src: "/catalog/g3.jpg", caption: "Обложка" },
    ],
    lead: "Помогает отличить голубя от очень убедительного кандидата. Раскладывается быстрее, чем формируется уверенное мнение.",
    story: ["Двенадцать птиц города в натуральную величину и по порядку убедительности. Тринадцатая страница пустая — для птенца голубя."],
    features: [
      { title: "13-я страница", text: "Пустая. Заполните, когда увидите. Институт пришлёт вам новую." },
      { title: "Влагостойкая бумага", text: "Работает под дождём, как и голуби." },
      { title: "Влезает в карман", text: "90 × 140 мм в сложенном виде." },
    ],
    specs: [
      ["Формат", "Гармошка, 90 × 140 мм"],
      ["Страниц", "13, из них одна пустая"],
      ["Птиц", "12 видов"],
      ["Бумага", "Плотная, матовая, влагостойкая"],
    ],
    variants: [{ name: "Стандарт", price: 1200 }],
    stock: 31,
    rating: 4.6,
    ratingCount: 41,
    dist: [74, 17, 6, 2, 1],
    reviews: [
      { author: "Николай", rating: 5, date: "2026-10-01", text: "Отличил голубя от вороны с первой попытки. От голубя голубя — пока нет.", helpful: 12 },
      { author: "Аня", rating: 4, date: "2026-08-18", text: "Ребёнок раскладывает и складывает весь день. Птиц выучил всех, вопросов задаёт больше, чем институт.", helpful: 8 },
    ],
    qa: [{ q: "А воробей там есть?", author: "Саша", a: "Есть, на странице 3. Подробности о его подозрительном сходстве — в версии № 2 на главной." }],
    related: ["zhurnal-videl-pokazalos", "binokl-karniz", "nabor-pervyj-ptenec"],
    popular: 6,
    added: 5,
  },
  {
    slug: "futbolka-ya-videl",
    sku: "НИИ-0417-05",
    category: "merch",
    name: "Футболка «Я видел птенца»",
    subtitle: "Утверждение, которое невозможно опровергнуть",
    badge: { text: "Новинка", tone: "new" },
    images: [
      { src: "/catalog/t1.jpg", caption: "Футболка" },
      { src: "/catalog/t2.jpg", caption: "В городе" },
      { src: "/catalog/t3.jpg", caption: "Печать крупно" },
    ],
    lead: "Пунктирный силуэт птенца на груди и оранжевый глаз. Носите — и пусть окружающие сами решают, видели вы или нет.",
    story: ["Пунктир — потому что птенца никто не видел целиком. Глаз — потому что он, судя по всему, видел нас."],
    features: [
      { title: "Плотный хлопок", text: "240 г/м², не просвечивает даже под прожектором учёного совета." },
      { title: "Шелкография", text: "Пунктир не стирается, в отличие от уверенности свидетелей." },
      { title: "Свободный крой", text: "Удобно сидеть на карнизе и подолгу смотреть вверх." },
    ],
    specs: [
      ["Состав", "100% хлопок, кулирка"],
      ["Плотность", "240 г/м²"],
      ["Крой", "Свободный, оверсайз"],
      ["Печать", "Шелкография, белый + оранжевый"],
      ["Цвет", "Графит"],
      ["Уход", "Стирка при 30°, наизнанку"],
    ],
    variantLabel: "Размер",
    variants: [
      { name: "S", price: 2490 },
      { name: "M", price: 2490 },
      { name: "L", price: 2490 },
      { name: "XL", price: 2490 },
      { name: "XXL", price: 2490, note: "Последние 3 штуки этого размера." },
    ],
    sizeChart: true,
    stock: 40,
    rating: 4.8,
    ratingCount: 57,
    dist: [85, 11, 2, 1, 1],
    reviews: [
      { author: "Дима", rating: 5, date: "2026-10-16", variant: "L", text: "Надел на работу. Трое спросили, правда ли видел. Двоим сказал «да». Теперь у нас в офисе рабочая группа.", helpful: 34, photos: ["/catalog/t2.jpg"] },
      { author: "Лена", rating: 5, date: "2026-09-28", variant: "S", text: "Оверсайз как надо, ткань плотная. Голуби во дворе смотрят с уважением.", helpful: 11 },
    ],
    qa: [{ q: "Маломерит?", author: "Кира", a: "Нет, крой свободный. Если сомневаетесь между двумя размерами — берите меньший или сверьтесь с таблицей." }],
    related: ["shoper-punktir", "znachok-obrazec", "zhurnal-videl-pokazalos"],
    popular: 2,
    added: 1,
  },
  {
    slug: "shoper-punktir",
    sku: "НИИ-0417-06",
    category: "merch",
    name: "Шопер «Пунктир»",
    subtitle: "Влезает набор наблюдателя и батон для голубей",
    images: [
      { src: "/catalog/o1.jpg", caption: "Шопер" },
      { src: "/catalog/o2.jpg", caption: "На плече" },
      { src: "/catalog/o3.jpg", caption: "Швы и печать" },
    ],
    lead: "Плотный холщовый шопер с пунктирным птенцом. Носит всё, что нужно для экспедиции, и немного больше.",
    story: ["Ручки прошиты крестом: выдерживают набор наблюдателя, два журнала и пакет корма «Без теорий»."],
    features: [
      { title: "Внутренний карман", text: "Для удостоверения руководителя экспедиции." },
      { title: "Нагрузка до 12 кг", text: "Проверено на мешке корма и двух сомнениях." },
    ],
    specs: [
      ["Материал", "Хлопковый канвас, 340 г/м²"],
      ["Размер", "38 × 42 см, ручки 65 см"],
      ["Печать", "Шелкография"],
      ["Нагрузка", "До 12 кг"],
    ],
    variants: [{ name: "Натуральный", price: 1490 }],
    stock: 37,
    rating: 4.7,
    ratingCount: 39,
    dist: [79, 14, 5, 1, 1],
    reviews: [
      { author: "Полина", rating: 5, date: "2026-10-08", text: "Ношу каждый день. В метро однажды спросили, где купить. Дала адрес института.", helpful: 14, photos: ["/catalog/r2.jpg"] },
    ],
    qa: [{ q: "Можно стирать в машинке?", author: "Таня", a: "Можно при 30°. Пунктир останется, птенец — тоже нет." }],
    related: ["futbolka-ya-videl", "znachok-obrazec", "korm-bez-teorij"],
    popular: 4,
    added: 3,
  },
  {
    slug: "znachok-obrazec",
    sku: "НИИ-0417-07",
    category: "merch",
    name: "Значок «Образец № 0417»",
    subtitle: "Знак участника экспедиции",
    images: [
      { src: "/catalog/p1.jpg", caption: "Значок" },
      { src: "/catalog/p2.jpg", caption: "На куртке" },
      { src: "/catalog/p3.jpg", caption: "Упаковка" },
    ],
    lead: "Эмалированный голубь с оранжевым глазом и переливом на шее. На обороте — номер вашей экспедиции.",
    story: ["Каждый значок пронумерован. Номер вносится в реестр института вместе с вашим именем, если вы его сообщите."],
    features: [
      { title: "Перелив шеи", text: "Зелёный и фиолетовый, как у оригинала. Голуби узнают своих." },
      { title: "Две застёжки", text: "Не слетит при резком повороте головы к карнизу." },
    ],
    specs: [
      ["Материал", "Латунь, твёрдая эмаль"],
      ["Размер", "32 мм"],
      ["Застёжка", "Две «бабочки»"],
      ["Упаковка", "Крафт-карточка в конверте"],
    ],
    variants: [{ name: "Стандарт", price: 590 }],
    stock: 120,
    rating: 4.9,
    ratingCount: 143,
    dist: [93, 5, 1, 1, 0],
    reviews: [
      { author: "Вася", rating: 5, date: "2026-10-19", text: "Повесил на рюкзак. Голубь у подъезда теперь смотрит на меня иначе.", helpful: 27 },
      { author: "Света", rating: 5, date: "2026-09-12", text: "Номер на обороте — гениально. У мужа 0882, у меня 0883. Мы теперь экспедиция.", helpful: 19 },
    ],
    qa: [{ q: "Номер можно выбрать?", author: "Миша", a: "Нет, номера выдаются по порядку. Но если вам выпадет 0417 — сообщите, это редкость." }],
    related: ["futbolka-ya-videl", "shoper-punktir", "figurka-obrazec"],
    popular: 7,
    added: 2,
  },
  {
    slug: "figurka-obrazec",
    sku: "НИИ-0417-08",
    category: "merch",
    name: "Фигурка «Образец № 0417»",
    subtitle: "Взрослый голубь в масштабе 1:2",
    badge: { text: "3D-просмотр", tone: "new" },
    images: [
      { src: "/catalog/f1.jpg", caption: "Фигурка" },
      { src: "/catalog/f2.jpg", caption: "На полке" },
      { src: "/catalog/f3.jpg", caption: "С упаковкой" },
    ],
    has3d: true,
    lead: "Керамическая копия эталонного взрослого голубя. Повертите её в 3D прямо здесь: со всех сторон это взрослый голубь.",
    story: [
      "Фигурку отлили по трёхмерной модели образца № 0417, которую отдел сканирования собрал по фотографиям. Модель можно покрутить в галерее — убедитесь, что признаков юности нет ни с одного ракурса.",
    ],
    features: [
      { title: "Масштаб 1:2", text: "16 см в высоту. Оригинал — 32 см, проверено линейкой." },
      { title: "Глазурь с переливом", text: "Шея меняет цвет от зелёного к фиолетовому при повороте." },
      { title: "Тяжёлое основание", text: "Не падает, даже если смотреть на неё с подозрением." },
    ],
    specs: [
      ["Материал", "Керамика, ручная глазуровка"],
      ["Высота", "16 см"],
      ["Вес", "480 г"],
      ["Масштаб", "1:2 к образцу № 0417"],
      ["Упаковка", "Подарочная коробка с ложементом"],
    ],
    variants: [
      { name: "Сизая", price: 3900 },
      { name: "Белая, лимитированная", price: 5400, note: "Тираж 100 штук. Белых голубей институт тоже не учитывает." },
    ],
    variantLabel: "Глазурь",
    stock: 9,
    rating: 5,
    ratingCount: 18,
    dist: [100, 0, 0, 0, 0],
    reviews: [
      { author: "Игорь Н.", role: "Руководитель экспедиции", rating: 5, date: "2026-10-12", text: "Стоит на рабочем столе. Коллеги спрашивают, почему голубь. Отвечаю: чтобы помнить, что ответы есть не на всё.", helpful: 21, photos: ["/catalog/r3.jpg"] },
    ],
    qa: [{ q: "Это точно взрослый голубь?", author: "Ольга", a: "Покрутите 3D-модель в галерее. Учёный совет проверил все ракурсы." }],
    related: ["znachok-obrazec", "nabor-pervyj-ptenec", "futbolka-ya-videl"],
    popular: 8,
    added: 0,
  },
  {
    slug: "korm-bez-teorij",
    sku: "НИИ-0417-09",
    category: "feed",
    name: "Корм «Без теорий»",
    subtitle: "Зерновая смесь для свидетелей",
    images: [
      { src: "/catalog/e1.jpg", caption: "Пакет 1 кг" },
      { src: "/catalog/e2.jpg", caption: "Состав" },
      { src: "/catalog/e3.jpg", caption: "Три фасовки" },
    ],
    lead: "Сбалансированная зерновая смесь. Голуби становятся разговорчивее, но о детстве всё равно молчат.",
    story: ["Состав подобран орнитологами и одобрен голубями двора на Таганке. Белый хлеб в смеси отсутствует — по просьбе голубей и ветеринаров."],
    features: [
      { title: "Без хлеба", text: "Только зерно, семечки и бобовые. Голуби одобрили, батоны обиделись." },
      { title: "Зип-лок", text: "Пакет закрывается, даже если голуби смотрят." },
    ],
    specs: [
      ["Состав", "Пшеница, ячмень, просо, горох, подсолнечник, кукуруза"],
      ["Без", "Хлеба, соли, красителей и теорий"],
      ["Упаковка", "Крафт-пакет с зип-локом"],
      ["Срок хранения", "12 месяцев"],
    ],
    variantLabel: "Фасовка",
    variants: [
      { name: "1 кг", price: 450 },
      { name: "3 кг", price: 1190, oldPrice: 1350 },
      { name: "10 кг", price: 3490, oldPrice: 4500, note: "Для опекунов голубятни." },
    ],
    stock: 210,
    rating: 4.8,
    ratingCount: 96,
    dist: [84, 12, 2, 1, 1],
    reviews: [
      { author: "Бабушка Валя", rating: 5, date: "2026-10-18", variant: "10 кг", text: "Раньше кормила батоном, теперь только этим. Голуби стали солиднее. Про птенцов молчат, я спрашивала.", helpful: 52, photos: ["/catalog/r4.jpg"] },
    ],
    qa: [{ q: "Подойдёт ли для попугая?", author: "Рома", a: "Попугаи вне компетенции института, но жалоб от них не поступало." }],
    related: ["shoper-punktir", "nabor-pervyj-ptenec", "znachok-obrazec"],
    popular: 9,
    added: 8,
  },
  {
    slug: "termos-nochnoj-dozor",
    sku: "НИИ-0417-10",
    category: "gear",
    name: "Термос «Ночной дозор»",
    subtitle: "Чай держит 12 часов, позицию — дольше",
    images: [
      { src: "/catalog/h1.jpg", caption: "Термос" },
      { src: "/catalog/h2.jpg", caption: "Закат на крыше" },
    ],
    lead: "Стальной термос для долгих наблюдений. Пока чай горячий, надежда тоже.",
    story: ["Отдел ночных наблюдений выдаёт такой термос каждому, кто остаётся на крыше после заката. Возвращают пустым все — и термос, и журнал."],
    features: [
      { title: "12 часов тепла", text: "Хватает на одну ночь и половину утренних сомнений." },
      { title: "Оранжевое кольцо", text: "Находится на ощупь в темноте, рядом с биноклем." },
      { title: "Крышка-кружка", text: "Наливайте себе. Голуби не пьют чай, проверено." },
    ],
    specs: [
      ["Материал", "Нержавеющая сталь 18/8, двойная стенка"],
      ["Держит тепло", "12 часов"],
      ["Покрытие", "Матовое, графит"],
      ["Вес", "380 г (0,5 л)"],
    ],
    variantLabel: "Объём",
    variants: [
      { name: "0,5 л", price: 1890 },
      { name: "0,75 л", price: 2290, oldPrice: 2590, note: "Для двоих или для одного очень терпеливого." },
    ],
    stock: 44,
    rating: 4.8,
    ratingCount: 52,
    dist: [83, 12, 3, 1, 1],
    reviews: [
      { author: "Дмитрий", rating: 5, date: "2026-10-11", variant: "0,75 л", text: "Сидел на крыше до четырёх утра. Чай остался горячим, птенец так и не появился. Термос тут ни при чём.", helpful: 12 },
    ],
    qa: [{ q: "Можно наливать кофе?", author: "Ира", a: "Можно. Институт рекомендует кофе для наблюдений после полуночи." }],
    related: ["fonarik-krasnyj-svet", "stulchik-nablyudatelya", "binokl-karniz"],
    popular: 10,
    added: 9,
  },
  {
    slug: "stulchik-nablyudatelya",
    sku: "НИИ-0417-11",
    category: "gear",
    name: "Стульчик наблюдателя",
    subtitle: "Складной, на четыре часа у карниза",
    images: [
      { src: "/catalog/c1.jpg", caption: "Стульчик" },
      { src: "/catalog/c2.jpg", caption: "На крыше у выхода" },
    ],
    lead: "Наблюдение — это в основном ожидание. Ждать сидя институт считает научно обоснованным.",
    story: ["Каркас выдерживает 110 кг, а это больше, чем любая гипотеза о птенцах. Складывается в чехол размером с батон."],
    features: [
      { title: "До 110 кг", text: "Выдерживает наблюдателя, рюкзак и груз ответственности." },
      { title: "Складывается за секунду", text: "Быстрее, чем голубь улетает с карниза." },
      { title: "Ремешок для переноски", text: "Оранжевый, чтобы не забыть стульчик на крыше." },
    ],
    specs: [
      ["Каркас", "Алюминий, чёрный"],
      ["Сиденье", "Оксфорд 600D"],
      ["Нагрузка", "До 110 кг"],
      ["Вес", "620 г"],
      ["В сложенном виде", "38 × 9 см"],
    ],
    variants: [{ name: "Стандарт", price: 1690, oldPrice: 1990 }],
    stock: 27,
    rating: 4.7,
    ratingCount: 34,
    dist: [76, 18, 4, 1, 1],
    reviews: [
      { author: "Галина П.", rating: 5, date: "2026-09-29", text: "Беру на дачу и смотрю на голубятню соседа. Сосед нервничает, стульчик удобный.", helpful: 9 },
    ],
    qa: [{ q: "Устойчив на гравии?", author: "Пётр", a: "Устойчив. Испытан на крыше, покрытой гравием и подозрениями." }],
    related: ["termos-nochnoj-dozor", "ponco-karniz", "binokl-karniz"],
    popular: 12,
    added: 11,
  },
  {
    slug: "ponco-karniz",
    sku: "НИИ-0417-12",
    category: "gear",
    name: "Дождевик-пончо «Карниз»",
    subtitle: "Голуби мокнут, наблюдатель — нет",
    images: [
      { src: "/catalog/u1.jpg", caption: "Пончо" },
      { src: "/catalog/u2.jpg", caption: "На улице после дождя" },
    ],
    lead: "Наблюдение не отменяется из-за погоды. Голуби под дождём ведут себя честнее — проверьте сами.",
    story: ["Полупрозрачная ткань не закрывает обзор, капюшон не шуршит. Сворачивается в собственный карман."],
    features: [
      { title: "Не шуршит", text: "Голуби не слышат вашего приближения. Почти." },
      { title: "Карман-чехол", text: "Сворачивается в него и помещается в шопер." },
    ],
    specs: [
      ["Материал", "Полиэстер с покрытием PU"],
      ["Водостойкость", "3000 мм"],
      ["Цвет", "Дымчатый серый"],
      ["Вес", "290 г"],
    ],
    variantLabel: "Размер",
    variants: [
      { name: "S–M", price: 2190 },
      { name: "L–XL", price: 2190 },
    ],
    stock: 19,
    rating: 4.6,
    ratingCount: 23,
    dist: [72, 20, 5, 2, 1],
    reviews: [
      { author: "Вера", rating: 4, date: "2026-10-06", variant: "S–M", text: "Отстояла в нём два часа под ливнем у вокзала. Сухая, голуби — мокрые и такие же взрослые.", helpful: 6 },
    ],
    qa: [{ q: "Подойдёт поверх рюкзака?", author: "Лёша", a: "Да, крой свободный. Рюкзак будет сухим, сомнения — нет." }],
    related: ["stulchik-nablyudatelya", "kepka-obrazec", "shoper-punktir"],
    popular: 16,
    added: 12,
  },
  {
    slug: "kepka-obrazec",
    sku: "НИИ-0417-13",
    category: "merch",
    name: "Кепка «Образец»",
    subtitle: "Козырёк от солнца и лишних вопросов",
    images: [
      { src: "/catalog/q1.jpg", caption: "Кепка" },
      { src: "/catalog/q2.jpg", caption: "На крючке" },
    ],
    lead: "Вышитый голубь спереди, оранжевая петелька сзади. Смотрите на карниз против солнца без прищура.",
    story: ["Вышивка — тем же голубем, что и на значке. Посвящённые узнают друг друга на расстоянии."],
    features: [
      { title: "Вышивка гладью", text: "Голубь не облезет, в отличие от уверенности свидетелей." },
      { title: "Регулируется", text: "Подходит на любую голову, даже очень задумчивую." },
    ],
    specs: [
      ["Материал", "Хлопок, твил"],
      ["Цвет", "Графит"],
      ["Застёжка", "Металлическая пряжка"],
      ["Размер", "Универсальный, 54–60"],
    ],
    variants: [{ name: "Графит", price: 1290 }],
    stock: 63,
    rating: 4.8,
    ratingCount: 47,
    dist: [84, 11, 3, 1, 1],
    reviews: [
      { author: "Тимур", rating: 5, date: "2026-10-01", text: "Ко мне подошёл человек и тихо спросил: «Вы тоже видели?». Кепка работает.", helpful: 21 },
    ],
    qa: [{ q: "Есть другие цвета?", author: "Аня", a: "Пока только графит. Институт выбирал цвет под оперение." }],
    related: ["hudi-punktir", "znachok-obrazec", "futbolka-ya-videl"],
    popular: 11,
    added: 10,
  },
  {
    slug: "hudi-punktir",
    sku: "НИИ-0417-14",
    category: "merch",
    name: "Худи «Пунктир»",
    subtitle: "Тёплое, с птенцом на груди",
    badge: { text: "Новинка", tone: "new" },
    images: [
      { src: "/catalog/w1.jpg", caption: "Худи" },
      { src: "/catalog/w2.jpg", caption: "В парке" },
    ],
    lead: "Плотное худи с маленьким вышитым птенцом. Единственный птенец, которого институт может гарантировать.",
    story: ["Начёс внутри, капюшон двойной. Для наблюдений поздней осенью, когда голуби становятся пухлыми и особенно подозрительными."],
    features: [
      { title: "Футер с начёсом", text: "380 г/м², тепло на крыше в октябре." },
      { title: "Вышитый птенец", text: "Маленький, на груди слева. Как и положено птенцу." },
      { title: "Карман-кенгуру", text: "Влезает определитель и горсть корма." },
    ],
    specs: [
      ["Состав", "80% хлопок, 20% полиэстер"],
      ["Плотность", "380 г/м²"],
      ["Цвет", "Серый меланж"],
      ["Уход", "Стирка при 30°, наизнанку"],
    ],
    variantLabel: "Размер",
    variants: [
      { name: "S", price: 4490 },
      { name: "M", price: 4490 },
      { name: "L", price: 4490 },
      { name: "XL", price: 4490 },
    ],
    sizeChart: true,
    stock: 28,
    rating: 4.9,
    ratingCount: 31,
    dist: [90, 7, 2, 1, 0],
    reviews: [
      { author: "Ксения", rating: 5, date: "2026-10-14", variant: "M", text: "Тёплое и мягкое. Птенец на груди — единственный, которого я видела. Ношу не снимая.", helpful: 15 },
    ],
    qa: [{ q: "Садится после стирки?", author: "Марк", a: "При 30° — нет. При 60° сядет так же, как надежда учёного совета." }],
    related: ["futbolka-ya-videl", "kepka-obrazec", "kruzhka-dva-golubya"],
    popular: 8,
    added: 0,
  },
  {
    slug: "kruzhka-dva-golubya",
    sku: "НИИ-0417-15",
    category: "merch",
    name: "Кружка «Двое»",
    subtitle: "Голубь и пунктир, 350 мл",
    images: [
      { src: "/catalog/m1.jpg", caption: "Кружка на подоконнике" },
      { src: "/designs/g-m.jpg", caption: "Кружка" },
    ],
    lead: "На кружке — взрослый голубь и пунктирный птенец рядом. Наливайте, пока второй не проявился.",
    story: ["Рисунок с той самой таблицы № 1 из годового отчёта института. Внутри оранжевая глазурь — видно, сколько осталось до конца наблюдения."],
    features: [
      { title: "350 мл", text: "Ровно на одно наблюдение средней продолжительности." },
      { title: "Посудомойка", text: "Рисунок выдерживает 500 циклов. Пунктир — тоже." },
    ],
    specs: [
      ["Материал", "Керамика"],
      ["Объём", "350 мл"],
      ["Внутри", "Оранжевая глазурь"],
      ["Уход", "Посудомоечная машина, СВЧ"],
    ],
    variants: [{ name: "Стандарт", price: 790 }],
    stock: 86,
    rating: 4.9,
    ratingCount: 72,
    dist: [91, 7, 1, 1, 0],
    reviews: [
      { author: "Лена", rating: 5, date: "2026-09-18", text: "Подарила коллеге, теперь в офисе спорят, кто на кружке второй. Работа встала, все довольны.", helpful: 18 },
    ],
    qa: [{ q: "Можно в микроволновку?", author: "Слава", a: "Можно. Голубь на кружке выдерживает 800 Вт и ни слова не говорит о детстве." }],
    related: ["otkrytki-pyat-versij", "znachok-obrazec", "hudi-punktir"],
    popular: 6,
    added: 13,
  },
  {
    slug: "otkrytki-pyat-versij",
    sku: "НИИ-0417-16",
    category: "paper",
    name: "Открытки «Пять версий»",
    subtitle: "По одной на каждую теорию",
    images: [
      { src: "/catalog/x1.jpg", caption: "Открытки в конвертах" },
      { src: "/designs/g-x.jpg", caption: "Набор целиком" },
    ],
    lead: "Пять акварельных голубей — пять рабочих версий института. Отправьте друзьям ту, в которую верите сами.",
    story: ["На обороте каждой открытки — краткое изложение версии и место для вашей подписи. Шестую версию предложите на главной."],
    features: [
      { title: "Пять версий", text: "Каждая с иллюстрацией и кратким обоснованием на обороте." },
      { title: "Крафт-конверты", text: "В комплекте. Голубиная почта не входит." },
    ],
    specs: [
      ["Формат", "А6, 105 × 148 мм"],
      ["Бумага", "Акварельная, 300 г/м²"],
      ["В наборе", "5 открыток и 5 конвертов"],
    ],
    variantLabel: "Набор",
    variants: [
      { name: "5 открыток", price: 490 },
      { name: "15 открыток", price: 1190, oldPrice: 1470, note: "Три полных комплекта версий." },
    ],
    stock: 140,
    rating: 4.8,
    ratingCount: 39,
    dist: [86, 9, 3, 1, 1],
    reviews: [
      { author: "Оля", rating: 5, date: "2026-10-09", variant: "5 открыток", text: "Отправила маме версию № 3. Мама позвонила и сказала, что всегда так думала.", helpful: 11 },
    ],
    qa: [{ q: "Можно отправить обычной почтой?", author: "Нина", a: "Можно. Голубиной не советуем — голуби предвзяты." }],
    related: ["kruzhka-dva-golubya", "zhurnal-videl-pokazalos", "pazl-najdi-ptenca"],
    popular: 13,
    added: 14,
  },
  {
    slug: "nabor-yunyj-ornitolog",
    sku: "НИИ-0417-17",
    category: "kids",
    name: "Набор «Юный орнитолог»",
    subtitle: "Первая экспедиция с 6 лет",
    badge: { text: "Новинка", tone: "new" },
    images: [
      { src: "/catalog/y1.jpg", caption: "Набор в коробке" },
      { src: "/catalog/y2.jpg", caption: "В деле" },
    ],
    lead: "Детский бинокль, лупа, карточки птиц и журнал юного наблюдателя. Пусть растут скептиками.",
    story: ["Ребёнок спрашивает, почему не видно птенцов голубей. Этот набор не даёт ответа, но даёт занятие на всё лето."],
    features: [
      { title: "Бинокль 4×30", text: "Лёгкий, прорезиненный, с мягкими наглазниками." },
      { title: "Карточки 12 птиц", text: "С подсказками, как отличить голубя от «почти голубя»." },
      { title: "Журнал юного наблюдателя", text: "С наклейками за каждое наблюдение. Наклейки «Птенец» нет." },
    ],
    specs: [
      ["Возраст", "6+"],
      ["Бинокль", "4×30, прорезиненный"],
      ["Лупа", "×3, диаметр 60 мм"],
      ["Коробка", "Картон с ручкой"],
    ],
    variants: [{ name: "Стандарт", price: 3490 }],
    stock: 22,
    rating: 4.9,
    ratingCount: 44,
    dist: [91, 6, 2, 1, 0],
    reviews: [
      { author: "Анна, мама Пети", rating: 5, date: "2026-09-25", text: "Сын неделю ходил с биноклем по двору и записывал голубей. Нашёл 47 взрослых. Требует продолжения.", helpful: 26 },
    ],
    qa: [{ q: "Бинокль настоящий?", author: "Игорь", a: "Настоящий, с просветлённой оптикой. Детский — только по весу." }],
    related: ["pazl-najdi-ptenca", "opredelitel-golub-ili-net", "kepka-obrazec"],
    popular: 5,
    added: 1,
  },
  {
    slug: "fonarik-krasnyj-svet",
    sku: "НИИ-0417-18",
    category: "gear",
    name: "Налобный фонарик «Красный свет»",
    subtitle: "Не будит голубей",
    images: [
      { src: "/catalog/l1.jpg", caption: "Фонарик" },
      { src: "/catalog/l2.jpg", caption: "На чердачной балке" },
    ],
    lead: "Красный режим не слепит и не пугает птиц. Белый — для журнала и поиска упавшего карандаша.",
    story: ["Ночная группа института работает только с красным светом. Голуби его не замечают — или делают вид."],
    features: [
      { title: "Красный режим", text: "Не нарушает ночное зрение, не будит голубей." },
      { title: "USB-C", text: "Заряжается от пауэрбанка прямо на крыше." },
      { title: "8 часов работы", text: "Хватает на одну ночную смену и отчёт." },
    ],
    specs: [
      ["Режимы", "Белый 200 лм, красный, мигание"],
      ["Аккумулятор", "1200 мА·ч, USB-C"],
      ["Защита", "IPX4"],
      ["Вес", "78 г"],
    ],
    variants: [{ name: "Стандарт", price: 1490 }],
    stock: 51,
    rating: 4.7,
    ratingCount: 29,
    dist: [79, 15, 4, 1, 1],
    reviews: [
      { author: "Никита", rating: 5, date: "2026-10-12", text: "Полез на чердак ночью. Голуби спали, я светил красным. Писк был, птенца — нет.", helpful: 14 },
    ],
    qa: [{ q: "Удобно в очках?", author: "Вадим", a: "Удобно, ремешок регулируется. Голуби в очках не замечены." }],
    related: ["termos-nochnoj-dozor", "binokl-karniz", "zhurnal-videl-pokazalos"],
    popular: 14,
    added: 6,
  },
  {
    slug: "pazl-najdi-ptenca",
    sku: "НИИ-0417-19",
    category: "kids",
    name: "Пазл «Найди птенца»",
    subtitle: "Тысяча голубей, ни одного птенца",
    images: [
      { src: "/catalog/z1.jpg", caption: "Коробка" },
      { src: "/catalog/z2.jpg", caption: "Собранный пазл" },
    ],
    lead: "Площадь, плотно заполненная голубями. Соберите целиком и убедитесь лично: птенца там нет.",
    story: ["Фото сделано отделом аэросъёмки. Каждого голубя на нём институт пересчитал дважды."],
    features: [
      { title: "Плотный картон", text: "2 мм, детали не расслаиваются." },
      { title: "Постер-подсказка", text: "Внутри — фото площади. Птенца нет и на нём." },
    ],
    specs: [
      ["Размер", "68 × 48 см (1000 деталей)"],
      ["Материал", "Картон 2 мм"],
      ["Возраст", "8+ (500), 12+ (1000)"],
    ],
    variantLabel: "Деталей",
    variants: [
      { name: "500", price: 1290 },
      { name: "1000", price: 1690 },
    ],
    stock: 33,
    rating: 4.8,
    ratingCount: 26,
    dist: [85, 10, 3, 1, 1],
    reviews: [
      { author: "Семья Ворониных", rating: 5, date: "2026-10-04", variant: "1000", text: "Собирали всей семьёй неделю. Птенца нет. Тёща считает, что он под последней деталью.", helpful: 19 },
    ],
    qa: [{ q: "Есть картинка-подсказка?", author: "Алина", a: "Есть, постер в коробке. На нём тоже только взрослые голуби." }],
    related: ["nabor-yunyj-ornitolog", "otkrytki-pyat-versij", "kruzhka-dva-golubya"],
    popular: 9,
    added: 3,
  },
  {
    slug: "kormushka-bez-teorij",
    sku: "НИИ-0417-20",
    category: "feed",
    name: "Кормушка «Без теорий»",
    subtitle: "Для балкона и наблюдений в упор",
    images: [
      { src: "/catalog/n1.jpg", caption: "Кормушка" },
      { src: "/catalog/n2.jpg", caption: "На балконе" },
    ],
    lead: "Деревянный домик с крышей. Голуби прилетают сами, вам остаётся смотреть, кто из них подозрительно мал.",
    story: ["Кормушка собрана из сосны и не требует инструментов. На жёрдочке помещаются два голубя или один очень взрослый."],
    features: [
      { title: "Без инструментов", text: "Собирается за пять минут и крепится на перила." },
      { title: "Крыша", text: "Корм не мокнет, голуби тоже." },
    ],
    specs: [
      ["Материал", "Сосна, крыша — металл"],
      ["Размер", "26 × 22 × 24 см"],
      ["Крепление", "Хомут на перила или подвес"],
    ],
    variants: [{ name: "Стандарт", price: 2490 }],
    stock: 17,
    rating: 4.7,
    ratingCount: 21,
    dist: [78, 16, 4, 1, 1],
    reviews: [
      { author: "Борис Н.", rating: 5, date: "2026-09-30", text: "Повесил на балкон — через час прилетели шесть голубей. Все взрослые. Наблюдаю дальше.", helpful: 8 },
    ],
    qa: [{ q: "Синицы тоже прилетают?", author: "Зоя", a: "Прилетают. Их птенцов институт, кстати, видел." }],
    related: ["korm-bez-teorij", "binokl-karniz", "stulchik-nablyudatelya"],
    popular: 15,
    added: 5,
  },
];

export const bySlug = (slug: string) => PRODUCTS.find((p) => p.slug === slug);
// вырезка товара на белом для дизайна «Каталог»: /designs/g-<буква первого фото>.jpg
export const cutout = (p: Product) => `/designs/g-${p.images[0].src.split("/").pop()![0]}.jpg`;
export const minPrice = (p: Product) => Math.min(...p.variants.map((v) => v.price));
export const rub = (n: number) => `${n.toLocaleString("ru-RU")} ₽`;
export const catLabel = (c: Category) => CATEGORIES.find((x) => x.id === c)?.label ?? "";

export const plural = (n: number, one: string, few: string, many: string) => {
  const m10 = n % 10;
  const m100 = n % 100;
  if (m10 === 1 && m100 !== 11) return one;
  if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return few;
  return many;
};

// SEO-подборки: отдельные страницы /catalog/podborka/<slug> и быстрые ссылки над каталогом
export type Collection = { slug: string; title: string; h1: string; lead: string; text: string; items: string[] };
export const COLLECTIONS: Collection[] = [
  {
    slug: "podarok-do-1000",
    title: "Подарок до 1 000 ₽",
    h1: "Подарки наблюдателю до 1 000 ₽",
    lead: "Недорогие подарки для тех, кто смотрит на карнизы чаще, чем в телефон.",
    text: "Значок, журнал, открытки, кружка и корм — подарки до тысячи рублей, которые объясняют увлечение лучше любых слов. Подойдут коллеге, другу или себе после очередного безуспешного выхода во двор.",
    items: ["znachok-obrazec", "zhurnal-videl-pokazalos", "otkrytki-pyat-versij", "kruzhka-dva-golubya", "korm-bez-teorij"],
  },
  {
    slug: "dlya-cherdaka",
    title: "Для чердака",
    h1: "Снаряжение для наблюдений на чердаке",
    lead: "Всё, что нужно, чтобы подняться под крышу и остаться там надолго.",
    text: "Чердак — главное место, где, по версии № 1, прячутся птенцы голубей. Красный фонарик не будит птиц, стульчик выручает в долгом ожидании, термос держит тепло, а журнал фиксирует писк, который голуби отрицают.",
    items: ["fonarik-krasnyj-svet", "stulchik-nablyudatelya", "termos-nochnoj-dozor", "zhurnal-videl-pokazalos", "binokl-karniz", "ponco-karniz"],
  },
  {
    slug: "nochnye-nablyudeniya",
    title: "Ночные наблюдения",
    h1: "Снаряжение для ночных наблюдений",
    lead: "Для тех, кто уверен, что птенцы выходят после полуночи.",
    text: "Версия № 4 утверждает, что птенцы голубей ведут ночной образ жизни. Проверить её помогут налобный фонарик с красным светом, термос на двенадцать часов, тёплое худи и бинокль, который видит в сумерках.",
    items: ["fonarik-krasnyj-svet", "termos-nochnoj-dozor", "hudi-punktir", "binokl-karniz", "stulchik-nablyudatelya"],
  },
  {
    slug: "dlya-detej",
    title: "Для детей",
    h1: "Наборы и игры для юных наблюдателей",
    lead: "Пусть растут любопытными и немного скептиками.",
    text: "Детский набор орнитолога, пазл на тысячу голубей, определитель городских птиц и значок участника экспедиции. Занятие на всё лето — и честный ответ на вопрос, почему птенцов голубей никто не видел.",
    items: ["nabor-yunyj-ornitolog", "pazl-najdi-ptenca", "opredelitel-golub-ili-net", "znachok-obrazec", "kepka-obrazec"],
  },
  {
    slug: "merch-s-ptencom",
    title: "Мерч с птенцом",
    h1: "Одежда и мерч с птенцом голубя",
    lead: "Единственные птенцы, которых институт может гарантировать.",
    text: "Футболка, худи, кепка, шопер, кружка, значок и керамическая фигурка. Пунктирный птенец на одежде — способ сказать «я видел» и не вступать в споры.",
    items: ["futbolka-ya-videl", "hudi-punktir", "kepka-obrazec", "shoper-punktir", "kruzhka-dva-golubya", "znachok-obrazec", "figurka-obrazec"],
  },
];
export const collectionBySlug = (slug: string) => COLLECTIONS.find((c) => c.slug === slug);
